import SiafLiteApiRepository from "../../external/siafLiteApi";

class EquipamentosService {
  constructor() {
    this.urlBase = "/estoque/equipamentos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  upsert(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upsert`).post(body);
  }
}

export default EquipamentosService;
